import { StatusScreen } from './StatusScreen';

/**
 * What `ErrorBoundary` shows when something throws while the interface is drawing: the big-type
 * crash page, filling the window. It sits above the router, so its buttons are full loads.
 */
export function ErrorScreen({ error }: { error?: unknown }) {
  return (
    <StatusScreen
      kind="crash"
      page
      line="Artwork stopped unexpectedly. Your changes are kept."
      error={error}
      actions={[
        { label: 'Reload page', primary: true, onClick: () => window.location.reload() },
        { label: 'All Files', onClick: () => window.location.assign('/?view=files') },
      ]}
    />
  );
}
